'use client'
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import PinDropIcon from '@mui/icons-material/PinDrop';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import SignpostIcon from '@mui/icons-material/Signpost';
import styles from './PersonalInfo.module.css';

interface PersonalInfoProps {
	name: string;
	surName?: string;
	email: string;
	phoneNumber?: string | null;
	document?: string;
	address?: {
		street: string;
		district: string;
		city: string;
		state: string;
		zipCode: string;
		number: string;
	};
}

export const PersonalInfo = ({
	name,
	surName,
	email,
	phoneNumber,
	document,
	address,
}: PersonalInfoProps) => {
	return (
		<div className={styles.personalInfoCard}>
			<div className={styles.cardTitle}>
				<CreditCardIcon className={styles.badgeIcon} />
				<h3 className={styles.titleText}>Informações Pessoais</h3>
			</div>

			<div className={styles.infoList}>
				<div className={styles.infoItem}>
					<p className={styles.infoLabel}>Nome Completo</p>
					<p className={styles.infoValue}>
						<PersonIcon className={styles.iconStyle} />
						{name} {surName}
					</p>
				</div>

				<div className={styles.infoItem}>
					<p className={styles.infoLabel}>E-mail</p>
					<p className={styles.infoValue}>
						<EmailIcon className={styles.iconStyle} />
						{email}
					</p>
				</div>

				<div className={styles.infoItem}>
					<p className={styles.infoLabel}>Telefone</p>
					<p className={styles.infoValue}>
						<PhoneIcon className={styles.iconStyle} />
						{phoneNumber || 'Não informado'}
					</p>
				</div>

				<div className={styles.infoItem}>
					<p className={styles.infoLabel}>CPF</p>
					<p className={styles.infoValue}>
						<FingerprintIcon className={styles.iconStyle} />
						{document || 'Não informado'}
					</p>
				</div>

				<div className={styles.infoItem}>
					<p className={styles.infoLabel}>CEP e Estado</p>
					<p className={styles.infoValue}>
						<PinDropIcon className={styles.iconStyle} />
						{address ? `${address.zipCode} - ${address.state}` : '---'}
					</p>
				</div>

				<div className={styles.infoItem}>
					<p className={styles.infoLabel}>Cidade e Bairro</p>
					<p className={styles.infoValue}>
						<LocationCityIcon className={styles.iconStyle} />
						{address ? `${address.city}, ${address.district}` : '---'}
					</p>
				</div>

				<div className={styles.infoItem}>
					<p className={styles.infoLabel}>Endereço</p>
					<p className={styles.infoValue}>
						<SignpostIcon className={styles.iconStyle} />
						{address ? `${address.street}, ${address.number}` : '---'}
					</p>
				</div>
			</div>
		</div>
	);
};
